import * as React from 'react'


export default function RadioElements({ item, id, onChange, value, disabled }) {

	const handleSwitchGlobalVision = e => {
		onChange(e.target.defaultValue)
	}

    return <>
        <input
            type="radio"
            id={`switch-alert-type-${id}`}
            name="switch-alert-type-toggle"
            value={item.value}
            onChange={handleSwitchGlobalVision}
            checked={value.toString() === item.value.toString()}
            disabled={item.disabled || disabled}
        />
        <label className={item.disabled || disabled ? 'multi-button-disabled' : ''} htmlFor={`switch-alert-type-${id}`}>{item.label}</label>
    </>
}